// import React, { useRef, useState } from 'react';
// import PageContainer from 'src/components/container/PageContainer';
// import DashboardCard from 'src/components/shared/DashboardCard';
// import { Button, Grid, MenuItem, Select, ToggleButton, ToggleButtonGroup } from '@mui/material';
// import { Box } from '@mui/system';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import { useMain } from '../hooks/useMain';
// import TextInputs from 'src/components/inputs/TextInputs';
// import RadioInputs from 'src/components/inputs/RadioInputs';
// import imageCompression from 'browser-image-compression';
// import TimeSlotSelector from 'src/components/inputs/TimeSlotSelector';
// import { useEffect } from 'react';

// const initialValue = {
//   name: '',
//   dob: '',
//   phone: '',
//   mail: '',
//   start: '',
//   end: '',
//   salary: '',
//   emergencyContact: '',
//   emergencyName: '',
//   gender: '',
//   dateOfJoining: '',
//   userType: '',
//   department: '',
//   incentive: '',
//   incentiveType: '%',
//   incentivePeriod: 'monthly', // Added incentivePeriod with default value
//   target: '',
//   img1: null,
//   img2: null,
//   address: '',
// };

// const initialFormValidation = {
//   nameValidation: false,
//   phoneValidation: false,
//   genderValidation: false,
//   mailValidation: false,
// };

// const incentive_types = ['%', 'INR'];
// const incentive_periods = ['monthly', 'weekly', 'daily']; // Added incentive periods

// const AddStaff = () => {
//   const { createStaff, activeBranchId, setShowMessage } = useMain();

//   const [formData, setFormData] = useState(initialValue);
//   const [formValidation, setFormValidation] = useState(initialFormValidation);

//   const [loading, setLoading] = useState(false);
//    const staffNameInputRef = useRef(null);

//   const nameValidation = !formData.name.trim();
//   const phoneValidation = !formData.phone || formData.phone.length !== 10;
//   const genderValidation = !formData.gender;
//   const mailValidation = !formData.mail;

//     useEffect(() => {
//     const timer = setTimeout(() => {
//       if (staffNameInputRef.current) {
//         staffNameInputRef.current.focus();
//       }
//     }, 100);

//     return () => clearTimeout(timer);
//   }, []);
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleImage = async (e) => {
//     const imageFile = e.target?.files[0];

//     if (imageFile) {
//       const maxSizeInBytes = 1024 * 1024; // 1MB
//       const currentSizeInBytes = imageFile.size;

//       if (currentSizeInBytes <= maxSizeInBytes) {
//         // If the image is already smaller than 1MB, no need to compress
//         setFormData({ ...formData, [e.target.name]: imageFile });
//       } else {
//         // Image needs compression
//         try {
//           const options = {
//             maxSizeMB: 1,
//             useWebWorker: true,
//           };
//           const compressedImage = await imageCompression(imageFile, options);
//           setFormData({ ...formData, [e.target.name]: compressedImage });
//         } catch (error) {
//           setShowMessage({
//             message: 'Error compressing image. Please try again.',
//             messageType: 'error',
//           });
//         }
//       }
//     }
//   };

//   // This logic disables the mouse wheel event
//   useEffect(() => {
//     const handleWheel = (e) => {
//       if (document.activeElement.type === 'number') {
//         document.activeElement.blur();
//       }
//     };

//     window.addEventListener('wheel', handleWheel);
//     return () => {
//       window.removeEventListener('wheel', handleWheel);
//     };
//   }, []);

//   const handleIncentiveTypeChange = (event, newIncentiveType) => {
//     if (newIncentiveType !== null) {
//       setFormData({ ...formData, incentiveType: newIncentiveType });
//     }
//   };

//   const handleSubmit = async () => {
//     const {
//       name,
//       dob,
//       phone,
//       mail,
//       start,
//       end,
//       salary,
//       emergencyContact,
//       emergencyName,
//       gender,
//       dateOfJoining,
//       userType,
//       department,
//       incentive,
//       incentiveType,
//       incentivePeriod, // Added incentivePeriod
//       target,
//       img1,
//       img2,
//       address,
//     } = formData;

//     const validation = {
//       nameValidation: !name.trim(),
//       phoneValidation: !phone || formData.phone.length !== 10,
//       genderValidation: !gender,
//       mailValidation: !mail,
//     };

//     setFormValidation((pre) => ({ ...pre, ...validation }));

//     if (Object.values(validation).some((item) => item)) return;

//     const formDataUpdated = new FormData();
//     formDataUpdated.append('name', name);
//     formDataUpdated.append('dob', dob);
//     formDataUpdated.append('gender', gender);
//     formDataUpdated.append('phone', phone);
//     formDataUpdated.append('mail', mail);
//     formDataUpdated.append('workingHrs', JSON.stringify({ start, end }));
//     formDataUpdated.append('salary', salary);
//     formDataUpdated.append(
//       'emergencyDetails',
//       JSON.stringify({ contactNo: emergencyContact, name: emergencyName }),
//     );
//     formDataUpdated.append('address', address);
//     formDataUpdated.append('dateOfJoining', dateOfJoining);
//     formDataUpdated.append('userType', userType);
//     formDataUpdated.append('department', department);
//     formDataUpdated.append('incentive', incentive);
//     formDataUpdated.append('incentiveType', incentiveType);
//     formDataUpdated.append('incentivePeriod', incentivePeriod); // Added incentivePeriod to form data
//     formDataUpdated.append('target', target);
//     formDataUpdated.append('branchDetails', activeBranchId);
//     if (img1) {
//       formDataUpdated.append('images', img1);
//     }
//     if (img2) {
//       formDataUpdated.append('images', img2);
//     }

//     try {
//       setLoading(true);
//       const res = await createStaff(formDataUpdated);
//       if (res?.statusCode === 200) {
//         setShowMessage({
//           message: res.message || 'Staff created successfully',
//           messageType: 'success',
//         });
//         setFormData((pre) => ({ ...initialValue }));
//         setFormValidation((pre) => ({ ...initialFormValidation }));
//       } else {
//         setShowMessage({ message: res.message || 'Something went wrong', messageType: 'error' });
//       }
//     } catch (error) {
//       setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };


//   return (
//     <PageContainer title="Add Staff" description="this is add Staff">
//       <DashboardCard title="Add Staff">
//         <Box style={{ marginTop: '20px' }}>
//           <Grid container spacing={3}>
//             <Grid item xs={12} md={4}>
//               <TextInputs
//                 ref={staffNameInputRef}
//                 title={'Name'}
//                 name={'name'}
//                 value={formData?.name}
//                 handleChange={handleChange}
//                 type={'text'}
//                 placeholder={'Name'}
//                 fieldValidation={nameValidation && formValidation.nameValidation}
//               />
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <TextInputs
//                 title={'Phone Number'}
//                 name={'phone'}
//                 value={formData?.phone}
//                 handleChange={handleChange}
//                 type={'number'}
//                 placeholder={'87******22'}
//                 fieldValidation={phoneValidation && formValidation.phoneValidation}
//               />
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <TextInputs
//                 title={'Email Address'}
//                 name={'mail'}
//                 value={formData?.mail}
//                 handleChange={handleChange}
//                 type={'email'}
//                 placeholder={'Email'}
//                 fieldValidation={mailValidation && formValidation.mailValidation}
//               />
//             </Grid>
//           </Grid>
//         </Box>

//         <Box style={{ marginTop: '20px' }}>
//           <Grid container spacing={3}>
//             <Grid item xs={12} md={4}>
//               <RadioInputs
//                 title={'Gender'}
//                 name={'gender'}
//                 value={formData?.gender}
//                 handleChange={handleChange}
//                 options={[
//                   { title: 'M', value: 'Male' },
//                   { title: 'F', value: 'Female' },
//                 ]}
//                 fieldValidation={genderValidation && formValidation.genderValidation}
//               />
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <TextInputs
//                 required={false}
//                 title={'Date of Birth'}
//                 name={'dob'}
//                 value={formData?.dob}
//                 handleChange={handleChange}
//                 type={'date'}
//               />
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <TextInputs
//                 required={false}
//                 title={'Address'}
//                 name={'address'}
//                 value={formData?.address}
//                 handleChange={handleChange}
//                 type={'text'}
//                 placeholder={'Address'}
//               />
//             </Grid>
//           </Grid>
//         </Box>

//         <Box style={{ marginTop: '20px' }}>
//           <Grid container spacing={3}>
//             <Grid item xs={12} md={4}>
//               <TextInputs
//                 required={false}
//                 title={'Emergency Contact Number'}
//                 name={'emergencyContact'}
//                 value={formData?.emergencyContact}
//                 handleChange={handleChange}
//                 type={'number'}
//                 placeholder={"Mobile No."}
//               />
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <TextInputs
//                 required={false}
//                 title={'Emergency Contact Person'}
//                 name={'emergencyName'}
//                 value={formData?.emergencyName}
//                 handleChange={handleChange}
//                 type={'text'}
//                 placeholder={"Name"}
//               />
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <TextInputs
//                 required={false}
//                 title={'Monthly Salary'}
//                 name={'salary'}
//                 min={'0'}
//                 placeholder={'0'}
//                 value={formData?.salary}
//                 handleChange={handleChange}
//                 type={'number'}
//               />
//             </Grid>
//           </Grid>
//         </Box>

//         <Box style={{ marginTop: '20px' }}>
//           <Grid container spacing={2}>
//             <Grid item xs={12} md={4}>
//               <Box>
//                 <Grid container spacing={3}>
//                   <Grid item xs={6}>
//                     <TimeSlotSelector
//                       required={false}
//                       title={'Shift Time'}
//                       name={'start'}
//                       value={formData?.start}
//                       handleChange={handleChange}
//                     />
//                   </Grid>
//                   <Grid item xs={6} mt={3}>
//                     <TimeSlotSelector
//                       required={false}
//                       // title={'end time'}
//                       name={'end'}
//                       value={formData?.end}
//                       handleChange={handleChange}
//                     />
//                   </Grid>
//                 </Grid>
//               </Box>
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <TextInputs
//                 required={false}
//                 title={'User Type'}
//                 name={'userType'}
//                 value={formData?.userType}
//                 handleChange={handleChange}
//                 type={'text'}
//                 placeholder={"Role"}
//               />
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <TextInputs
//                 required={false}
//                 title={'Department'}
//                 name={'department'}
//                 value={formData?.department}
//                 handleChange={handleChange}
//                 type={'text'}
//                 placeholder={"Position"}
//               />
//             </Grid>
//           </Grid>
//         </Box>

//         <Box style={{ marginTop: '20px' }}>
//           <Grid container spacing={3}>
//             <Grid item xs={12} md={4}>
//               <TextInputs
//                 required={false}
//                 title={'Target Amount'}
//                 name={'target'}
//                 value={formData?.target}
//                 min={'0'}
//                 handleChange={handleChange}
//                 type={'number'}
//               placeholder={'0'}
//               />
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <TextInputs
//                 required={false}
//                 title={'Incentive'}
//                 name={'incentive'}
//                 value={formData?.incentive}
//                 handleChange={handleChange}
//                 type={'number'}
//                 min={'0'}
//               placeholder={'0'}
//               />
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <div style={{ marginBottom: '6px', fontWeight: 'bold', color: 'black' }}>
//                 Incentive Type
//               </div>
//               <ToggleButtonGroup
//                 value={formData.incentiveType}
//                 exclusive
//                 onChange={handleIncentiveTypeChange}
//                 aria-label="incentive type"
//                 fullWidth
//                 sx={{
//                   borderRadius: '4px',
//                   height: '50px',
//                   width:'180px',
//                   backgroundColor: '#f0f0f0',
//                 }}
//               >
//                 {incentive_types.map((type) => (
//                   <ToggleButton
//                     key={type}
//                     value={type}
//                     aria-label={type}
//                     sx={{
//                       color: '#000',
//                       backgroundColor: '#e0e0e0',
//                       height:'3.4rem',
//                       '&.Mui-selected': {
//                         backgroundColor: '#6174DD',
//                         color: '#fff',
//                         '&:hover': {
//                           backgroundColor: '#6174DD',
//                         },
//                       },
//                       '&:not(.Mui-selected)': {
//                         '&:hover': {
//                           backgroundColor: '#d0d0d0',
//                         },
//                       }
//                     }}
//                   >
//                     {type}
//                   </ToggleButton>
//                 ))}
//               </ToggleButtonGroup>
//             </Grid>
//           </Grid>
//         </Box>

//         <Box style={{ marginTop: '20px' }}>
//           <Grid container spacing={3}>
//             <Grid item xs={12} md={4}>
//               <div style={{ marginBottom: '5px', fontWeight: 'bold', color: 'black' }}>
//                 Incentive Period
//               </div>
//               <Select
//                 name="incentivePeriod"
//                 value={formData?.incentivePeriod}
//                 onChange={handleChange}
//                 fullWidth
//                 sx={{ height: '50px' }}
//               >
//                 {incentive_periods.map((period) => (
//                   <MenuItem key={period} value={period}>
//                     {period.charAt(0).toUpperCase() + period.slice(1)}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <TextInputs
//                 required={false}
//                 title={'Date of Joining'}
//                 name={'dateOfJoining'}
//                 value={formData?.dateOfJoining}
//                 handleChange={handleChange}
//                 type={'date'}
//                 max={new Date().toISOString().split('T')[0]}
//               />
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <TextInputs
//                 required={false}
//                 title={'Upload Photo (max size: 1MB)'}
//                 name={'img1'}
//                 value={formData?.img1 || ' '}
//                 handleChange={handleImage}
//                 type={'file'}
//               />
//             </Grid>
//           </Grid>
//         </Box>

//         <Box style={{ marginTop: '20px' }}>
//           <Grid container spacing={3}>
//             <Grid item xs={12} md={4}>
//               <TextInputs
//                 required={false}
//                 title={'Upload Id (max size: 1MB)'}
//                 name={'img2'}
//                 value={formData?.img2 || ' '}
//                 handleChange={handleImage}
//                 type={'file'}
//               />
//             </Grid>
//           </Grid>
//         </Box>

//         <div style={{ width: '200px', margin: '3rem auto' }}>
//           {loading ? (
//             <ShowLoader />
//           ) : (
//             <Button
//               variant="contained"
//               fullWidth
//               color="primary"
//               target="_blank"
//               sx={{
//                 background: '#6174DD',
//               }}
//               onClick={handleSubmit}
//             >
//               Add Staff
//             </Button>
//           )}
//         </div>
//       </DashboardCard>
//     </PageContainer>
//   );
// };

// export default AddStaff;

import React, { useRef, useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import DashboardCard from 'src/components/shared/DashboardCard';
import { Button, Grid, MenuItem, Select, ToggleButton, ToggleButtonGroup, Card, CardContent, Typography, Box, Switch, FormControlLabel, Tooltip,   } from '@mui/material';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import { useMain } from '../hooks/useMain';
import TextInputs from 'src/components/inputs/TextInputs';
import RadioInputs from 'src/components/inputs/RadioInputs';
import imageCompression from 'browser-image-compression';
import TimeSlotSelector from 'src/components/inputs/TimeSlotSelector';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useEffect } from 'react';

const initialValue = {
  name: '',
  dob: '',
  phone: '',
  mail: '',
  start: '',
  end: '',
  salary: '',
  emergencyContact: '',
  emergencyName: '',
  gender: '',
  dateOfJoining: '',
  userType: '',
  department: '',
  incentive: '',
  incentiveType: '%',
  incentivePeriod: 'monthly',
  target: '',
  img1: null,
  img2: null,
  address: '',
  allowIncentive: false, 
};

const initialFormValidation = {
  nameValidation: false,
  phoneValidation: false,
  genderValidation: false,
  mailValidation: false,
  incentiveValidation: false,        
  incentivePeriodValidation: false,   
  incentiveTypeValidation: false,  
};

const incentive_types = ['%', 'INR'];
const incentive_periods = ['monthly', 'weekly', 'daily'];

const userType = ['Admin', 'receptionist', 'Artist', 'Cleaning staff']

const AddStaff = () => {
  const { createStaff, activeBranchId, setShowMessage } = useMain();

  const [formData, setFormData] = useState(initialValue);
  const [formValidation, setFormValidation] = useState(initialFormValidation);
  const [loading, setLoading] = useState(false);
  const staffNameInputRef = useRef(null);

  const nameValidation = !formData.name.trim();
  const phoneValidation = !formData.phone || formData.phone.length !== 10;
  const genderValidation = !formData.gender;
  const mailValidation = !formData.mail;

  // Calculate incentive amount
  const calculateIncentiveAmount = () => {
    if (!formData.target || !formData.incentive) return '0';

    const target = parseFloat(formData.target);
    const incentive = parseFloat(formData.incentive);

    if (formData.incentiveType === '%') {
      return (target * (incentive / 100)).toFixed(2);
    } else {
      return incentive.toFixed(2);
    }
  };

  const incentiveAmount = calculateIncentiveAmount();
const targetValue = parseFloat(formData.target) || 0;

const getCalculationText = () => {
  const inc = parseFloat(formData.incentive);
  if (!inc) return 'Enter incentive to calculate';

  if (formData.incentiveType === '%') {
    return targetValue === 0
      ? `No target: ${inc}% of every service amount`
      : `${targetValue} × ${inc}% = ${incentiveAmount}`;
  }
  return targetValue === 0
    ? `No target: ₹${inc} credited from the first sale`
    : `₹${incentiveAmount}`;
};

const incentiveInfoText = formData.allowIncentive
  ? 'Incentive is ON: the staff starts earning incentive on sales once the target is crossed. If the target is 0 or empty, no target is needed and the incentive is credited from the first sale, on the full bill amount.'
  : 'Incentive is OFF: no incentive will be credited, even if target and incentive values are saved.';
  useEffect(() => {
    const timer = setTimeout(() => {
      if (staffNameInputRef.current) {
        staffNameInputRef.current.focus();
      }
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Cleans a phone value: digits only, keeps the LAST 10 digits
  const cleanPhone = (raw) => {
    const digits = String(raw || '').replace(/\D/g, ''); // remove spaces, dashes, +, brackets
    return digits.length > 10 ? digits.slice(-10) : digits;
  };

  const handlePhoneChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: cleanPhone(value) }));
  };
  const handleAllowIncentiveChange = (e) => {
    setFormData({ ...formData, allowIncentive: e.target.checked });
  };

  const handleImage = async (e) => {
    const imageFile = e.target?.files[0];

    if (imageFile) {
      const maxSizeInBytes = 1024 * 1024;
      const currentSizeInBytes = imageFile.size;

      if (currentSizeInBytes <= maxSizeInBytes) {
        setFormData({ ...formData, [e.target.name]: imageFile });
      } else {
        try {
          const options = {
            maxSizeMB: 1,
            useWebWorker: true,
          };
          const compressedImage = await imageCompression(imageFile, options);
          setFormData({ ...formData, [e.target.name]: compressedImage });
        } catch (error) {
          setShowMessage({
            message: 'Error compressing image. Please try again.',
            messageType: 'error',
          });
        }
      }
    }
  };

  useEffect(() => {
    const handleWheel = (e) => {
      if (document.activeElement.type === 'number') {
        document.activeElement.blur();
      }
    };

    window.addEventListener('wheel', handleWheel);
    return () => {
      window.removeEventListener('wheel', handleWheel);
    };
  }, []);

  const handleIncentiveTypeChange = (event, newIncentiveType) => {
    if (newIncentiveType !== null) {
      setFormData({ ...formData, incentiveType: newIncentiveType });
    }
  };

  const handleSubmit = async () => {
    const {
      name,
      dob,
      phone,
      mail,
      start,
      end,
      salary,
      emergencyContact,
      emergencyName,
      gender,
      dateOfJoining,
      userType,
      department,
      incentive,
      incentiveType,
      incentivePeriod,
      target,
      img1,
      img2,
      address,
      allowIncentive,
    } = formData;

    const validation = {
      nameValidation: !name.trim(),
      phoneValidation: !phone || formData.phone.length !== 10,
      genderValidation: !gender,
      mailValidation: !mail,
      incentiveValidation: allowIncentive && (!incentive || !(Number(incentive) > 0)),
      incentivePeriodValidation: allowIncentive && !incentivePeriod,
      incentiveTypeValidation: allowIncentive && !incentiveType,
    };

    setFormValidation((pre) => ({ ...pre, ...validation }));

    if (Object.values(validation).some((item) => item)) return;

    const formDataUpdated = new FormData();
    formDataUpdated.append('name', name);
    formDataUpdated.append('dob', dob);
    formDataUpdated.append('gender', gender);
    formDataUpdated.append('phone', cleanPhone(phone));
    formDataUpdated.append('mail', mail);
    formDataUpdated.append('workingHrs', JSON.stringify({ start, end }));
    formDataUpdated.append('salary', salary);
    formDataUpdated.append(
      'emergencyDetails',
    JSON.stringify({ contactNo: cleanPhone(emergencyContact), name: emergencyName }),
    );
    formDataUpdated.append('address', address);
    formDataUpdated.append('dateOfJoining', dateOfJoining);
    formDataUpdated.append('userType', userType);
    formDataUpdated.append('department', department);
    formDataUpdated.append('incentive', incentive);
    formDataUpdated.append('incentiveType', incentiveType);
    formDataUpdated.append('incentivePeriod', incentivePeriod);
    formDataUpdated.append('target', target);
    formDataUpdated.append('branchDetails', activeBranchId);
    formDataUpdated.append('allowIncentive', allowIncentive);   
    if (img1) {
      formDataUpdated.append('images', img1);
    }
    if (img2) {
      formDataUpdated.append('images', img2);
    }

    try {
      setLoading(true);
      const res = await createStaff(formDataUpdated);
      if (res?.statusCode === 200) {
        setShowMessage({
          message: res.message || 'Staff created successfully',
          messageType: 'success',
        });
        setFormData((pre) => ({ ...initialValue }));
        setFormValidation((pre) => ({ ...initialFormValidation }));
      } else {
        setShowMessage({ message: res.message || 'Something went wrong', messageType: 'error' });
      }
    } catch (error) {
      setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageContainer title="Add Staff" description="this is add Staff">
      <DashboardCard title="Add Staff">
        {/* Section 1: Staff Details */}
        <Card sx={{ mb: 3, border: '1px solid #e0e0e0' }}>
          <CardContent>
            <Typography variant="h6" sx={{ mb: 3, color: '#6174DD', fontWeight: 'bold' }}>
              Basic Details
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <TextInputs
                  ref={staffNameInputRef}
                  title={'Name'}
                  name={'name'}
                  value={formData?.name}
                  handleChange={handleChange}
                  type={'text'}
                  placeholder={'Name'}
                  fieldValidation={nameValidation && formValidation.nameValidation}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextInputs
                  title={'Phone Number'}
                  name={'phone'}
                  value={formData?.phone}
                  handleChange={handlePhoneChange}
                  type={'text'}
                  placeholder={'87******22'}
                  fieldValidation={phoneValidation && formValidation.phoneValidation}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <RadioInputs
                  title={'Gender'}
                  name={'gender'}
                  value={formData?.gender}
                  handleChange={handleChange}
                  options={[
                    { title: 'M', value: 'Male' },
                    { title: 'F', value: 'Female' },
                  ]}
                  fieldValidation={genderValidation && formValidation.genderValidation}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextInputs
                  title={'Email Address'}
                  name={'mail'}
                  value={formData?.mail}
                  handleChange={handleChange}
                  type={'email'}
                  placeholder={'Email'}
                  fieldValidation={mailValidation && formValidation.mailValidation}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextInputs
                  required={false}
                  title={'Address'}
                  name={'address'}
                  value={formData?.address}
                  handleChange={handleChange}
                  type={'text'}
                  placeholder={'Address'}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        {/* Section 2: Employment Details */}
        <Card sx={{ mb: 3, border: '1px solid #e0e0e0' }}>
          <CardContent>
            <Typography variant="h6" sx={{ mb: 3, color: '#6174DD', fontWeight: 'bold' }}>
              Employment Details
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <TextInputs
                  required={false}
                  title={'Date of Joining'}
                  name={'dateOfJoining'}
                  value={formData?.dateOfJoining}
                  handleChange={handleChange}
                  type={'date'}
                  max={new Date().toISOString().split('T')[0]}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <Box>
                  <Grid container spacing={2} alignItems="flex-end">
                    <Grid item xs={6}>
                      <TimeSlotSelector
                        required={false}
                        title={'Shift Start Time'}
                        name={'start'}
                        value={formData?.start}
                        handleChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TimeSlotSelector
                        required={false}
                        title={'Shift End Time'}
                        name={'end'}
                        value={formData?.end}
                        handleChange={handleChange}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>

              {/* <Grid item xs={12} md={4}>
                <TextInputs
                  required={false}
                  title={'User Type'}
                  name={'userType'}
                  value={formData?.userType}
                  handleChange={handleChange}
                  type={'text'}
                  placeholder={"Role"}
                />
              </Grid> */}
              <Grid item xs={12} md={4}>
                <div style={{ marginBottom: '5px', fontWeight: 'bold', color: 'black' }}>
                  User Type
                </div>
                <Select
                  name="userType"
                  value={formData?.userType || ''}
                  onChange={handleChange}
                  fullWidth
                  sx={{ height: '50px' }}
                >
                  {userType.map((type) => (
                    <MenuItem key={type} value={type}>
                      {type}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>

              <Grid item xs={12} md={4}>
                <TextInputs
                  required={false}
                  title={'Department'}
                  name={'department'}
                  value={formData?.department}
                  handleChange={handleChange}
                  type={'text'}
                  placeholder={'Position'}
                />
              </Grid>

              {/* Emergency Contact Section */}
              <Grid item xs={12} md={4}>
                <TextInputs
                  required={false}
                  title={'Emergency Contact Person'}
                  name={'emergencyName'}
                  value={formData?.emergencyName}
                  handleChange={handleChange}
                  type={'text'}
                  placeholder={'Name'}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextInputs
                  required={false}
                  title={'Emergency Contact Number'}
                  name={'emergencyContact'}
                  value={formData?.emergencyContact}
                  handleChange={handlePhoneChange}
                  type={'text'}
                  placeholder={'Mobile No.'}
                />
              </Grid>

              {/* Upload Sections */}
              <Grid item xs={12} md={4}>
                <TextInputs
                  required={false}
                  title={'Upload Photo (max size: 1MB)'}
                  name={'img1'}
                  value={formData?.img1 || ' '}
                  handleChange={handleImage}
                  type={'file'}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextInputs
                  required={false}
                  title={'Upload Id (max size: 1MB)'}
                  name={'img2'}
                  value={formData?.img2 || ' '}
                  handleChange={handleImage}
                  type={'file'}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextInputs
                  required={false}
                  title={'Date of Birth'}
                  name={'dob'}
                  value={formData?.dob}
                  handleChange={handleChange}
                  type={'date'}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        {/* Section 3: Salary Details */}
        <Card sx={{ mb: 3, border: '1px solid #e0e0e0' }}>
          <CardContent>
            <Typography variant="h6" sx={{ mb: 3, color: '#6174DD', fontWeight: 'bold' }}>
              Salary Details
            </Typography>
            <Grid container spacing={3}>
              {/* ROW 1: always visible */}
              <Grid item xs={12} md={4}>
                <TextInputs
                  required={false}
                  title={'Monthly Salary'}
                  name={'salary'}
                  min={'0'}
                  placeholder={'0'}
                  value={formData?.salary}
                  handleChange={handleChange}
                  type={'number'}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <div
                  style={{
                    marginBottom: '5px',
                    fontWeight: 'bold',
                    color: 'black',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                  }}
                >
                  Allow Incentive
                  <Tooltip title={incentiveInfoText} arrow placement="top">
                    <InfoOutlinedIcon sx={{ fontSize: 15, color: '#9aa0a6', cursor: 'pointer' }} />
                  </Tooltip>
                </div>
                <FormControlLabel
                  control={
                    <Switch
                      checked={formData.allowIncentive}
                      onChange={handleAllowIncentiveChange}
                      color="primary"
                    />
                  }
                  label={formData.allowIncentive ? 'ON' : 'OFF'}
                />
              </Grid>

              {/* Only when toggle is ON */}
              {formData.allowIncentive && (
                <>
                  <Grid item xs={12} sx={{ py: '0 !important' }} />

                  {/* ROW 2: Target (optional), Incentive*, Period* */}
                  <Grid item xs={12} md={4}>
                    <TextInputs
                      required={false}
                      title={'Target Amount (optional, empty = 0)'}
                      name={'target'}
                      value={formData?.target}
                      min={'0'}
                      handleChange={handleChange}
                      type={'number'}
                      placeholder={'0'}
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <TextInputs
                      title={'Incentive'}
                      name={'incentive'}
                      value={formData?.incentive}
                      handleChange={handleChange}
                      type={'number'}
                      min={'0'}
                      placeholder={'0'}
                      fieldValidation={
                        formData.allowIncentive && formValidation.incentiveValidation
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <div style={{ marginBottom: '5px', fontWeight: 'bold', color: 'black' }}>
                      Incentive Period <span style={{ color: 'red' }}>*</span>
                    </div>
                    <Select
                      name="incentivePeriod"
                      value={formData?.incentivePeriod}
                      onChange={handleChange}
                      fullWidth
                      error={formValidation.incentivePeriodValidation}
                      sx={{ height: '50px' }}
                    >
                      {incentive_periods.map((period) => (
                        <MenuItem key={period} value={period}>
                          {period.charAt(0).toUpperCase() + period.slice(1)}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>

                  {/* ROW 3: Type*, Calculation */}
                  <Grid item xs={12} md={4}>
                    <div style={{ marginBottom: '6px', fontWeight: 'bold', color: 'black' }}>
                      Incentive Type <span style={{ color: 'red' }}>*</span>
                    </div>
                    <ToggleButtonGroup
                      value={formData.incentiveType}
                      exclusive
                      onChange={handleIncentiveTypeChange}
                      aria-label="incentive type"
                      fullWidth
                      sx={{ borderRadius: '4px', height: '50px', backgroundColor: '#f0f0f0' }}
                    >
                      {incentive_types.map((type) => (
                        <ToggleButton
                          key={type}
                          value={type}
                          aria-label={type}
                          sx={{
                            color: '#000',
                            backgroundColor: '#e0e0e0',
                            height: '3.4rem',
                            '&.Mui-selected': {
                              backgroundColor: '#6174DD',
                              color: '#fff',
                              '&:hover': { backgroundColor: '#6174DD' },
                            },
                            '&:not(.Mui-selected)': { '&:hover': { backgroundColor: '#d0d0d0' } },
                          }}
                        >
                          {type}
                        </ToggleButton>
                      ))}
                    </ToggleButtonGroup>
                  </Grid>

                  <Grid item xs={12} md={8}>
                    <div style={{ marginBottom: '6px', fontWeight: 'bold', color: 'black' }}>
                      Incentive Calculation
                    </div>
                    <Box
                      sx={{
                        height: '50px',
                        px: 2,
                        border: '1px solid #e0e0e0',
                        borderRadius: '4px',
                        backgroundColor: targetValue === 0 ? '#eef8f0' : '#f9f9f9',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <Typography variant="subtitle1" color="primary" fontWeight="bold" noWrap>
                        {getCalculationText()}
                      </Typography>
                    </Box>
                    {targetValue === 0 && (
                      <div style={{ fontSize: '12px', color: '#8a8f98', marginTop: '4px' }}>
                        Target is 0, so the staff does not need to achieve any target. The incentive
                        is credited from the first sale.
                      </div>
                    )}
                  </Grid>
                </>
              )}
            </Grid>
          </CardContent>
        </Card>

        {/* Submit Button */}
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <Box sx={{ width: '200px' }}>
            {loading ? (
              <ShowLoader />
            ) : (
              <Button
                variant="contained"
                fullWidth
                color="primary"
                sx={{
                  background: '#6174DD',
                  py: 1.5,
                  fontSize: '1rem',
                  fontWeight: 'bold',
                }}
                onClick={handleSubmit}
              >
                Add Staff
              </Button>
            )}
          </Box>
        </Box>
      </DashboardCard>
    </PageContainer>
  );
};

export default AddStaff;

